import { Text } from '@mnd-frontend/ui/publish/components';

const EmailDistribution = () => (
  <>
    <Text as="h3" variant="headlineSmall">
      Email distribution
    </Text>
    <Text as="p" variant="body">
      Email distribution allows you to handpick contact lists to send your story to. The contacts on
      the contact lists you selected will receive the full story in their inbox.
    </Text>
    <Text as="p" variant="body">
      Even if a contact is present in multiple contact lists, they will still only receive one
      email.
    </Text>
    <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
      Pro tip!
    </Text>
    <Text as="p" variant="body">
      Keeping your contact lists updated will improve reader engagement and help build long-lasting
      connections with your audience.
    </Text>
  </>
);

export default EmailDistribution;
